<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">How to get IVANHOE subids in cloaked links</h3>
            </div>
        </div>
        <!-- Second Row of Posts -->
        <d-row>
            <d-col lg="12">
                <d-card class="mb-3">
                    <d-card-header class="border-bottom">
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-network' }">2. Connect networks</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-intergration' }">3. Connect integrations</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'snippet' }">4. Place Ivanhoe.io tag</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'affiliate-link' }">5. Choose direct or cloaked links</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><u>6. Ready to start</u></h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body>
                        <d-row>
                            <d-col lg="6" md="12" sm="12">
                                <p class="mt-5 font-weight-bold">Do you have cloaked links on your affiliate website and want to track your affiliate earnings in your Google Analytics reports? Just use our API for cloaked links in order to connect Ivanhoe.io with your affiliate website and your Google Analytics account!</p>
                                <p>A lot of affiliates are cloaking their links to make them Search Engine Friendly, show a waiting screen or because it just looks nicer. So for example http://ds1.nl/c/?wi=187181&si=982&li=1177805&ws= will become http://affiliatewebsite.com/go/advertiser. Ivanhoe.io can work with cloaked links if the affiliate is able to insert the IVANHOE sub id into the affiliate url from a cloaked link.</p>
                                <p class="font-weight-bold">How to get IVANHOE subids in cloaked links?</p>
                                <p>You just need to create AND pass a user session using the Ivanhoe.io API. Just follow the instructions below and you'll get started in no time!</p>
                                <p>To start using it you need a Developer ID and a password. You can get your Developer ID and password in your Ivanhoe.io account (Account > API Access). Currently the Ivanhoe.io API has only one resource to track user session. It returns a sub-id that should be passed to affiliate networks.</p>
                                <p>Allowed methods: <span class="font-weight-bold">POST</span></p>
                                <p class="font-weight-bold">Required parameters:</p>
                                <p><u>hostname.</u> The hostname of your website with a protocol <u>google_client_id.</u> A google client ID from cookies. Usually it looks like this: GA1.2.11111111.11111111 and stored on cookies with the key <span class="font-weight-bold">_ga</span>. The Ivanhoe.io API uses HTTP methods and a RESTful endpoint structure. You can use Basic auth to get access rights.</p>
                                <p class="font-weight-bold">An example request:</p>
                                <p><span class="font-weight-bold">POST</span>/api/v1/session HTTP/1.1</p>
                                <p><span class="font-weight-bold">Host: </span>ivanhoe.io</p>
                                <p><span class="font-weight-bold">Authorization: </span>Basic dGVzDpzZWNyZXQ=</p>
                                <p><span class="font-weight-bold">Cache-Control: </span>no-cache</p>
                                <p><span class="font-weight-bold">Content-Type: </span>application/x-www-form-urlencoded</p>
                                <p class="mr-5 script-tag"><span class="font-weight-bold">Body: </span>hostname=http://test.com&google_client_id=GA1.2.11111111.11111111</p>
                            </d-col>
                            <d-col lg="6" md="12" sm="12">
                                <d-col class="mt-5 border">
                                    <h4 class="ml-3 mt-5">Your current API key</h4>
                                    <d-form>
                                        <d-form-row class="mx-4">
                                            <d-col md="12" class="mt-3 mb-2">
                                                <d-form-text tag="p" class="text-muted m-0">Developer id</d-form-text>
                                            </d-col>
                                            <d-col cols="9" class="mb-3 script-tag">
                                                <d-form-text tag="h6" class="m-0">
                                                    {{ Developer.developer_id }}
                                                </d-form-text>
                                            </d-col>
                                            <d-col md="12" class="mt-3 mb-2">
                                                <d-form-text tag="p" class="text-muted mb-2 m-0">Password</d-form-text>
                                                <d-form-text tag="h6" :class="['alert', apiCssClassName]">
                                                    <span class="text-white">{{ apiText }}</span>
                                                </d-form-text>
                                                <div v-if="isAvailable">
                                                    <button type="button" @click="deleteDeveloperId" class="btn mr-3 mt-3 btn-danger btn-sm disable-api">Disable API access</button>
                                                    <button type="button" @click="updateDeveloperId" class="btn mt-3 btn-success btn-sm generate-api">Generate API key</button>
                                                </div>
                                                <button type="button" v-else @click="restore" class="mt-3 btn btn-secondary btn-sm">Enable API access</button>
                                            </d-col>
                                            <d-col md="12" class="mt-4 mb-4">
                                                <d-form-text tag="p" class="m-0">
                                                    Warning This key gives full access to your Ivanhoe.io sub-id generation. Keep it safe and do not publish.
                                                </d-form-text>
                                            </d-col>
                                        </d-form-row>
                                    </d-form>
                                </d-col>
                            </d-col>
                        </d-row>
                    </d-card-body>
                    <d-card-footer>
                        <d-row>
                            <d-col class="d-flex justify-content-start">
                                <d-link tag="button" :to="{ name: 'affiliate-link' }" class="btn btn-secondary">Previous step</d-link>
                            </d-col>
                            <d-col class="d-flex justify-content-end">
                                <d-link tag="button" :to="{ name: 'dashboard' }" class="btn btn-success">Done</d-link>
                            </d-col>
                        </d-row>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
    import { DeveloperService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                percent: 100,
                tag: '',
                type: 'disable',
                apiText: '',
                apiCssClassName: '',
                Developer: '',
                isAvailable: true
            };
        },
        methods: {
            async getDeveloperId() {
                try {
                    this.Developer = await DeveloperService.get()
                    if (this.Developer !== null && this.Developer.deleted_at == null) {
                        this.apiText = "Please use your current Developer Id and password or generate new ones."
                        this.apiCssClassName = "alert-warning"
                    } else {
                        this.apiText = "To start using the IVANHOE.io API and get your API access key you need to enable Api access."
                        this.apiCssClassName = "alert-warning"
                    }

                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            async updateDeveloperId() {
                try {
                    this.Developer = await DeveloperService.update()
                    this.apiText = this.Developer.showed_pass
                    this.apiCssClassName = "alert-success"
                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            async deleteDeveloperId() {
                try {
                    this.Developer = await DeveloperService.delete()
                    this.isAvailable = false
                    this.apiText = "To start using the IVANHOE.io API and get your API acces key you need to enable Api access."
                    this.apiCssClassName = "alert-danger"
                } catch(e) {
                    console.log(e)
                    this.showNotification('warn', 'We have a problem', 'Oops! cant get developer id')
                }
            },

            restore() {
                this.isAvailable = true
                this.apiText = "Please use your current Developer Id and password or generate new ones."
                this.apiCssClassName = "alert-warning"
            }
        },

        created () {
            this.getDeveloperId()
        }
    };
</script>
